var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLike = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66626 5.34457L6.89203 4.03905C6.94842 3.71297 6.69766 3.41473 6.36711 3.41473H4.70916C4.54484 3.41473 4.41971 3.26724 4.44631 3.1049L4.65836 1.81064C4.69281 1.60038 4.68297 1.38523 4.62948 1.17899C4.58516 1.00815 4.45335 0.870969 4.28 0.815281L4.23361 0.800378C4.12884 0.766723 4.0145 0.774554 3.91572 0.822151C3.807 0.874541 3.72746 0.9701 3.69798 1.08375L3.54575 1.67058C3.49732 1.8573 3.42677 2.03753 3.3358 2.20782C3.20289 2.45664 2.99739 2.65577 2.78378 2.83985L2.32338 3.23658C2.19357 3.34844 2.1254 3.51596 2.14017 3.68679L2.40006 6.69245C2.4239 6.96814 2.6544 7.17978 2.93081 7.17978H4.41837C5.53238 7.17978 6.48311 6.40359 6.66626 5.34457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12956 3.17503C1.25796 3.16949 1.36794 3.26609 1.37901 3.39413L1.68992 6.98982C1.70989 7.22079 1.52796 7.41986 1.29565 7.41986C1.07683 7.41986 0.899902 7.24235 0.899902 7.02394V3.41481C0.899902 3.28628 1.00115 3.18057 1.12956 3.17503Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Like.25bb53f8.svg";
export { ForwardRef as ReactComponent };